import { useQuery } from "@tanstack/react-query";
import { useGetVendorId } from "../global/User";
import api from '../../services/api';

export const useGetDashboard = () => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get(`/statistics/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['dashboard'], queryFn: fetchData, enabled: true });
};